import React, { FC, useContext } from 'react'

import { FormattedMessage, useIntl } from 'react-intl'

import { ProfileFieldType } from 'components/page/ProfileCommon/ProfileCommon.types'
import { ProfileContext } from 'components/page/UserProfile/Context/CreateProfileContext'
import { Nowrap } from 'components/presentational/input'
import {
  renderTextHeight,
  renderTextWeight,
} from 'components/presentational/UnitSelect'
import { findLexemeProfileField } from 'functions/findLexemeProfileField'
import { mergeColonLexeme } from 'functions/mergeColonLexeme'
import { GQLDatingProfileLexicalOptionType } from 'generated-graphql/graphql'

export const SwitchProfileField: FC<{
  type?: ProfileFieldType
  data: {} | [] | string | number | null | undefined | boolean
  lexemes?: GQLDatingProfileLexicalOptionType[] | null
}> = ({ type, data, lexemes }) => {
  const intl = useIntl()
  const { gender } = useContext(ProfileContext)

  switch (type) {
    case ProfileFieldType.Age:
      const age = data as number

      return (
        <FormattedMessage
          id="profile.age"
          values={{
            data: age,
          }}
          defaultMessage="{data} {data, plural, one {год} few {года} many {лет} other {лет}}"
        />
      )

    case ProfileFieldType.Weight:
      const weightInKg = (data as number) / 1000
      const renderWeight = mergeColonLexeme(renderTextWeight(intl, weightInKg))
      return <Nowrap>{renderWeight}</Nowrap>

    case ProfileFieldType.Height:
      const heightInCm = (data as number) / 10
      const renderHeight = mergeColonLexeme(renderTextHeight(intl, heightInCm))
      return <Nowrap>{renderHeight}</Nowrap>

    case ProfileFieldType.WithTitle:
      const details = mergeColonLexeme(
        findLexemeProfileField(data as [], lexemes as [], gender)
      )

      if (details) {
        return <>{details}</>
      }

      return null

    case ProfileFieldType.WithTitleWithoutLexeme:
      return <>{mergeColonLexeme(data)}</>

    case ProfileFieldType.SingleWithoutLexeme:
      return <>{data}</>

    default:
      return <>{findLexemeProfileField([data as string], lexemes!, gender)}</>
  }
}
